import { render, staticRenderFns } from "./SortColumnIcon.vue?vue&type=template&id=3f042c4e&scoped=true"
import script from "./SortColumnIcon.vue?vue&type=script&lang=js"
export * from "./SortColumnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f042c4e",
  null
  
)

export default component.exports